(function () {
  'use strict';

  function workflowThumbnailsService(thumbnailsDataService) {

    function getThumbnails(workflowId, workflowData) {
      var allPaths = [];
      workflowData.Phases.forEach(function (phase) {
          var informationParts = phase.InformationParts.filter(function (i) {
              return i.Access.View && !i.IsRemoved && i.BlobSummaries;
          });

          var blobSummaryPaths = [];
          informationParts.forEach(function (informationPart) {
              var blobSummaries = informationPart.BlobSummaries.filter(function (blobSummary) {
                  return !blobSummary.IsRemoved;
              });
              blobSummaryPaths = blobSummaryPaths.concat(blobSummaries.map(function (blob) {
                  return blob.Path;
              }));
          });

          allPaths = allPaths.concat(blobSummaryPaths);
          var requiredDownloadPaths = phase.RequiredDownloads.map(function (filtered) {
              return filtered.Path;
          });
          allPaths = allPaths.concat(requiredDownloadPaths);
      });

      return thumbnailsDataService.loadThumbnailsForObjectPaths('workflows/' + workflowId,
          allPaths
      ).then(function (data) {
          Object.keys(data).forEach(function (key) {
              var matchingThumbnailObj = data[key];
              if (matchingThumbnailObj.Thumbnails && matchingThumbnailObj.Thumbnails.length > 0) {
                  var prefix = matchingThumbnailObj.IsTemplate ? 'gettemplate' : 'getupload';
                  matchingThumbnailObj.ThumbnailUrl = '/files/' + prefix + '?blobreference=' + matchingThumbnailObj.Thumbnails[0] + '&fileName='+ matchingThumbnailObj.Thumbnails[0];
              }
          })
          return data;
      });
    }

      return {
          getThumbnails: getThumbnails
      };
  }

  workflowThumbnailsService.$inject = ['thumbnailsDataService'];

  angular.module('ecap.workflow').factory('workflowThumbnailsService', workflowThumbnailsService);
})();
